(() => {
  if (window.cmssCartLoaded) return;
  window.cmssCartLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('.quick-cart');
  if (!drawer) return;
  let version = 0, timer, busy = false, opener;
  const cache = new Map(), seen = new Set();
  function track(action, extra = {}) {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    document.dispatchEvent(new CustomEvent('cmss:cart_action', {detail: {action, ...extra, preview: !!window.Shopify?.designMode || !!window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main', version: 1}}));
  }
  const refresh = () => document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
  function syncOpen() {
    const open = !!drawer.querySelector('.quick-cart__wrapper.active');
    drawer.setAttribute('aria-hidden', String(!open));
    document.querySelectorAll('[data-cmss-cart-open]').forEach(a => a.setAttribute('aria-expanded', String(open)));
    if (open) schedule();
  }
  function setCount(cart) {
    if (!cart || !Number.isInteger(cart.item_count)) return;
    document.querySelectorAll('[data-cmss-cart-open]').forEach(a=>{a.setAttribute('aria-label',`Cart with ${cart.item_count} ${cart.item_count===1?'item':'items'}`);const b=a.querySelector('b');if(b)b.textContent=cart.item_count;});
  }
  function schedule() {clearTimeout(timer); timer = setTimeout(load, 120);}
  async function json(url, options) {
    const response = await fetch(url, {credentials:'same-origin', ...options});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'We couldn’t update your cart. Please try again.');
    return data;
  }
  function el(tag, cls, text) {const n=document.createElement(tag); if(cls)n.className=cls; if(text)n.textContent=text; return n;}
  function safeProduct(p, cartIds) {
    const words = [p.type, p.title, ...(p.tags || [])].join(' ');
    return p.available && !cartIds.has(p.id) && !/furniture|bookcase|bookshel(?:f|ves)|\b(?:chair|chairs|desk|desks|table|tables|sofa|sofas|couch|couches|cabinet|cabinets|cubby|cubbies|cot|cots)\b/i.test(words) && !p.requires_selling_plan;
  }
  async function related(id) {
    if (!cache.has(id)) cache.set(id, json(`${root}recommendations/products.json?product_id=${id}&limit=10&intent=related`).then(d => d.products || []).catch(e => {cache.delete(id); throw e;}));
    return cache.get(id);
  }
  const offerCode = 'CMSS-EXTRAS10';
  async function selectedOffers() {
    const response=await fetch(`${root}cart?section_id=cmss-cart-offers`,{credentials:'same-origin'});
    if(!response.ok) return [];
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    return JSON.parse(doc.querySelector('[data-cmss-offer-products]')?.textContent || '[]').map(p=>({...p,cmssOffer:true}));
  }
  async function applyOffer() {
    const cart=await json(`${root}cart.js`);
    const codes=[...new Set([...(cart.discount_codes || []).map(d=>d.code),offerCode])];
    const updated=await json(`${root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
    const applied=(updated.discount_codes || []).some(d=>d.code.toUpperCase()===offerCode && d.applicable) || updated.items.some(i=>(i.line_level_discount_allocations || []).some(d=>d.discount_application.title===offerCode || d.discount_application.title==='CMSS Selected Extras — 10% Off'));
    setCount(updated);
    return applied;
  }
  async function load() {
    if (!drawer.querySelector('.quick-cart__wrapper.active')) return;
    const target=drawer.querySelector('[data-cmss-recommendations]');
    const seq=++version;
    try {
      const cart=await json(`${root}cart.js`);
      setCount(cart);
      if (!target) return;
      const signature=cart.items.map(i=>`${i.key}:${i.quantity}`).join('|');
      if (target.dataset.signature===signature) return;
      const ids=new Set(cart.items.map(i=>i.product_id));
      const seeds=[...ids].slice(-3).reverse();
      const [groups, offers]=await Promise.all([Promise.all(seeds.map(id=>related(id).catch(()=>[]))),selectedOffers().catch(()=>[])]);
      if (seq!==version || !target.isConnected) return;
      const products=offers.filter(p=>safeProduct(p,ids));
      for(let rank=0;rank<10;rank++) for(const group of groups) {const p=group[rank];if(p && safeProduct(p,ids) && !products.some(x=>x.id===p.id)) products.push(p);}
      target.replaceChildren(); target.dataset.signature=signature;
      target.hidden=!products.length;
      if (!products.length) return;
      target.append(el('h3','cmss-cart-recs__title','Complete your classroom'));
      target.append(el('p','cmss-cart-recs__intro',products.slice(0,3).some(p=>p.cmssOffer)?'Save 10% on marked extras when you add them here.':'Useful finds, based on your cart.'));
      const list=el('ul','cmss-cart-recs__list');
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:cart.currency}).format(amount/100);
      for(const p of products.slice(0,3)) {
        const row=el('li','cmss-cart-recs__item'), link=el('a','cmss-cart-recs__image');
        link.href=`${root}products/${encodeURIComponent(p.handle)}`;link.tabIndex=-1;link.setAttribute('aria-hidden','true');
        if(p.featured_image){const img=el('img');img.src=p.featured_image;img.alt='';img.width=64;img.height=64;img.loading='lazy';link.append(img);}
        const info=el('div','cmss-cart-recs__info'), title=el('a','cmss-cart-recs__name',p.title);title.href=link.href;info.append(title);
        const price=el('p','cmss-cart-recs__price');
        const showPrice=(amount)=>{price.replaceChildren();if(p.cmssOffer){price.append(el('s','',money(amount)),el('strong','',money(amount-Math.floor(amount/10))),el('span','cmss-cart-recs__offer','10% off'));}else price.textContent=`${p.price_varies?'From ':''}${money(amount)}`;};
        showPrice(p.price);info.append(price);
        const variants=p.variants.filter(v=>v.available);
        let button;
        if((p.cmssOffer || p.variants.length===1) && variants.length) {button=el('button','cmss-cart-recs__add','Add');button.type='button';button.dataset.cmssUpsell=variants[0].id;button.dataset.productId=p.id;button.setAttribute('aria-label',`Add ${p.title} to cart`);}
        else {button=el('a','cmss-cart-recs__add','Choose');button.href=link.href;button.setAttribute('aria-label',`Choose options for ${p.title}`);}
        if(p.cmssOffer && button.tagName==='BUTTON') {
          button.dataset.cmssOffer='true';
          showPrice(variants[0].price);
          if(variants.length>1) {
            const select=el('select','cmss-cart-recs__variants');select.setAttribute('aria-label',`Options for ${p.title}`);
            variants.forEach(v=>{const option=el('option','',v.title);option.value=v.id;select.append(option);});
            select.addEventListener('change',()=>{const v=variants.find(v=>String(v.id)===select.value);button.dataset.cmssUpsell=v.id;showPrice(v.price);});
            info.append(select);
          }
        }
        row.append(link,info,button);list.append(row);
      }
      target.append(list);
      if(products.slice(0,3).some(p=>p.cmssOffer)) target.append(el('p','cmss-cart-recs__terms','Selected extras only. Cannot combine with other product or order discounts.'));
      const impression = products.slice(0,3).map(p=>p.id).join(',');
      if(!seen.has(impression)){seen.add(impression);track('recommendations_viewed',{product_ids:products.slice(0,3).map(p=>p.id)});}
    } catch {if(target)target.hidden=true;}
  }
  document.addEventListener('click', event => {
    const open=event.target.closest('[data-cmss-cart-open]');
    if(open && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button===0){event.preventDefault();opener=open;refresh();track('drawer_opened');}
  });
  drawer.addEventListener('click', event => {
    if(busy && event.target.closest('.cmss-cart-checkout, a[href$="#cmss-quote-review"]')) {event.preventDefault();event.stopImmediatePropagation();}
  }, true);
  drawer.addEventListener('click', async event => {
    const button=event.target.closest('[data-cmss-upsell]');
    if(!button || busy) return;
    event.preventDefault();busy=true;button.disabled=true;button.textContent='Adding…';
    const actions=drawer.querySelectorAll('.cmss-cart-checkout, a[href$="#cmss-quote-review"]');
    actions.forEach(a=>a.setAttribute('aria-disabled','true'));
    drawer.setAttribute('aria-busy','true');
    const status=drawer.querySelector('[data-cmss-cart-status]');status.textContent='';
    let added=false;
    try {
      await json(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.cmssUpsell),quantity:1}]})});
      added=true;
      track('recommendation_added',{product_id:Number(button.dataset.productId),variant_id:Number(button.dataset.cmssUpsell),quantity:1,offer:!!button.dataset.cmssOffer});
      if(button.dataset.cmssOffer) {
        const applied=await applyOffer();
        status.textContent=applied?'Item added. Your 10% selected-extras discount is applied.':'Item added. The 10% offer could not be combined with your current discount. Review your savings before checkout.';
        track(applied?'offer_applied':'offer_not_applied');
      } else status.textContent='Item added to your cart.';
      refresh();
    }
    catch(error){
      if(added){status.textContent='Item added, but the discount could not be applied. Use CMSS-EXTRAS10 at checkout for eligible extras.';refresh();}
      else {status.textContent=error.message;button.disabled=false;button.textContent='Add';}
      track('recommendation_error',{added});
    }
    finally {busy=false;actions.forEach(a=>a.removeAttribute('aria-disabled'));drawer.removeAttribute('aria-busy');}
  });
  drawer.addEventListener('keydown',event=>{if(event.key==='Escape'){drawer.querySelector('[data-modal-close]')?.click();opener?.focus();}});
  new MutationObserver(records=>{if(records.some(r=>r.type==='attributes'))syncOpen();if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1 && (n.matches?.('.quick-cart__items, .quick-cart__form, .quick-cart__empty-state') || n.querySelector?.('.quick-cart__items, .quick-cart__empty-state')))))schedule();}).observe(drawer,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  document.addEventListener('cart:updated',event=>{setCount(event.detail?.cart);schedule();});
  syncOpen();
})();
